import { render, staticRenderFns } from "./MemberOrder.vue?vue&type=template&id=53f679d5&scoped=true&"
import script from "./MemberOrder.vue?vue&type=script&lang=js&"
export * from "./MemberOrder.vue?vue&type=script&lang=js&"
import style0 from "./MemberOrder.vue?vue&type=style&index=0&id=53f679d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f679d5",
  null
  
)

export default component.exports